import * as React from "react"
import { Info, LucideIcon } from "lucide-react"
import { Tooltip, TooltipTrigger, TooltipContent } from "./tooltip"
import { cn } from "../../lib/utils"

export interface IconTooltipProps {
    content: string | React.ReactNode
    icon?: LucideIcon
    iconClassName?: string
    tooltipClassName?: string
}

export const IconTooltip = React.forwardRef<SVGSVGElement, IconTooltipProps>(
    ({ content, icon: Icon = Info, iconClassName, tooltipClassName, ...props }, ref) => {
        return (
            <Tooltip>
                <TooltipTrigger asChild>
                    <Icon
                        ref={ref}
                        className={cn("h-3 w-3 text-muted-foreground cursor-help", iconClassName)}
                        {...props}
                    />
                </TooltipTrigger>
                <TooltipContent className={tooltipClassName}>
                    {typeof content === 'string' ? <p>{content}</p> : content}
                </TooltipContent>
            </Tooltip>
        )
    }
)
IconTooltip.displayName = "IconTooltip"

